import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import ReactDOM from "react-dom/client";
import App from "./App";
import { config } from "./config/env";
import { messages as deMessages } from "./locales/de/messages.mjs";
import { messages as enMessages } from "./locales/en/messages.mjs";
import "./theme/fonts.css";
import "./theme/print.css";

Sentry.init({
  dsn: config.sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

if (config.posthogToken) {
  posthog.init(config.posthogToken, {
    api_host: config.posthogHost ?? "https://eu.i.posthog.com",
    persistence: "memory", // GDPR: nothing written to browser storage
    autocapture: false, // iframe widget — DOM click capture is noisy/risky
    capture_pageview: false, // handled manually via PostHogPageview in App.tsx
    capture_pageleave: false, // not meaningful in iframe
    session_recording: {
      maskAllInputs: true, // guard against accidental recording of billing fields
    },
  });
}

i18n.load("en", enMessages);
i18n.load("de", deMessages);
i18n.activate("en");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <I18nProvider i18n={i18n}>
    <App />
  </I18nProvider>,
);
